<template>
  <div class="example_mov">
    <div class="ex_text"><v-icon>local_movies</v-icon>PC/모바일 인터플레이 실행 영상</div>
    <div class="mov_select_box">
      <input type="radio" name="inter_mov" value="pc" v-model="viewSample" @change="changeMov"/>
      <span @click="clickRadio('pc')">PC 인터플레이</span>
      <input type="radio" name="inter_mov" value="mobile" v-model="viewSample" @change="changeMov"/>
      <span @click="clickRadio('mobile')">모바일 인터플레이</span>
    </div>
    <video class="video" id="video_ip" controls>
      <source src="//cdn.interworksmedia.co.kr/sample/interplay_mobile.mp4" type="video/mp4" />
    </video>
  </div>
</template>

<script>
  import * as url from '@/assets/links'
  export default {
    name: 'sampleVideo',
    data () {
      return {
        viewSample: 'mobile'
      }
    },
    methods: {
      changeMov () {
        let video = document.getElementById('video_ip')
        if (video.src === '' & this.viewSample === 'mobile') {
          return
        }
        let src = this.viewSample === 'pc' ? this.pcUrl : this.mUrl
        if (video.src.indexOf(src) !== -1) return
        video.src = src
        video.currentTime = 0
        video.play()
      },
      clickRadio (nm) {
        this.viewSample = nm
        this.changeMov()
      }
    },
    computed: {
      mUrl () {
        return url.mVideoUrl
      },
      pcUrl () {
        return url.pcVideoUrl
      }
    },
    mounted () {
      let t = document.getElementById('video_ip')
      if (t.canPlayType('video/mp4')) {
        // t.setAttribute('muted', '')
        t.muted = true
        t.setAttribute('loop', '')
        t.setAttribute('autoplay', '')
        t.setAttribute('playsinline', '')
      }
    }
  }
</script>

<style scoped>
  .example_mov {
    padding-bottom: 10px;
  }
  .example_mov i {
    vertical-align: middle;
    margin-right: 5px;
    color: #689f38;
  }
  .ex_text {
    text-align: left;
    margin-left: 10px;
    margin-bottom: 5px;
    height: 30px;
    line-height: 30px;
    color: #689f38;
    font-weight: 500;
  }
  .video {
    object-fit: scale-down;
    max-width: 95%;
    border: 2px solid #d6d6d6;
    border-radius: 5px;
    min-height: 100px;
  }
  .mov_select_box {
    color: #689f38;
  }
  .mov_select_box input:hover, .mov_select_box span:hover {
    cursor: pointer;
  }
  @media screen and (min-width: 1920px){
    .video {
      max-width: 750px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// SampleVideo.vue?44eeb5e2